if (!customElements.get('collapsible-section')) {
    customElements.define(
      'collapsible-section',
      class CollapsibleSection extends HTMLElement {
        static get observedAttributes() {
          return ['open'];
        }
  
        defaultSettings = {
          mblimit: 100,
          dtlimit: 150,
          needFocus: true,
        };
  
        constructor() {
          super();
          this.showMore = this.querySelector('.js-show-more');
          this.showLess = this.querySelector('.js-show-less');
          this.content = this.querySelector('.js-content');
          this.settings = this.getAttribute('settings');
          this.isInitialized = false;
          // Bind once so the same reference is used for add/removeEventListener.
          this.handleToggle = () => this.toggleOpen();
        }

        getSettings() {
          // Idempotent: once parsed, this.settings is an object — don't re-parse.
          if (this.settings && typeof this.settings === 'object') {
            return;
          }

          if (!this.settings) {
            this.settings = this.defaultSettings;
            return;
          }

          try {
            const parsed = JSON.parse(this.settings);
            this.settings = parsed;
          } catch (error) {
            console.error('Error during parsing');
            this.settings = this.defaultSettings;
          }
        }
  
        toggleOpen() {
          this.toggleAttribute('open');
        }
  
        updateView(toOpen) {
          // Ensure settings are parsed before reading mblimit/dtlimit, since
          // attributeChangedCallback can run before connectedCallback.
          this.getSettings();

          this.showMore?.classList.toggle('hidden', toOpen);
          this.showLess?.classList.toggle('hidden', !toOpen);
  
          const maxHeight = toOpen ? `${this.content.scrollHeight}px` : null;
          this.content.style.setProperty(
            '--mb-max-height',
            maxHeight || `${this.settings.mblimit}px`
          );
          this.content.style.setProperty(
            '--dt-max-height',
            maxHeight || `${this.settings.dtlimit}px`
          );
  
          if (!toOpen && this.settings.needFocus && this.isInitialized) {
            this.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
  
        attributeChangedCallback(name, oldValue, newValue) {
          if (name === 'open' && oldValue !== newValue) {
            this.updateView(newValue === '');
          }
        }
  
        connectedCallback() {
          // Same handler reference each time, so re-attaching in the theme
          // editor (disconnect/reconnect) can't stack duplicate listeners.
          this.showMore.addEventListener('click', this.handleToggle);
          this.showLess.addEventListener('click', this.handleToggle);
          this.getSettings();

          // Size the content to match the current open state before enabling
          // the transition, so sections that are expanded by default render at
          // their full height immediately instead of starting clipped at the
          // collapsed limit / animating open on first paint.
          this.updateView(this.hasAttribute('open'));
          this.content.classList.add('is-ready');
          this.isInitialized = true;
        }

        disconnectedCallback() {
          this.showMore.removeEventListener('click', this.handleToggle);
          this.showLess.removeEventListener('click', this.handleToggle);
        }
      }
    );
  }
  